module.exports = __webpack_public_path__ + "img/direction_horizon.83778e9d.png";